module.exports = __webpack_public_path__ + "img/20190803105729765.815ecaa6.png";